package floris.graphics.core.utils

import kotlinx.browser.document
import org.w3c.dom.HTMLVideoElement
import org.w3c.dom.asList

fun pauseAllVideos(tagName: String = "video") {
    val elements = document.getElementsByTagName(tagName).asList()
    elements.forEach {
        (it as? HTMLVideoElement)?.pause()
    }
}

fun reloadAllVideos(tagName: String = "video") {
    val elements = document.getElementsByTagName(tagName).asList()
    elements.forEach {
        (it as? HTMLVideoElement)?.load()
    }
}
